const keyboardKeys = {
  ENTER: 'Enter',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_LEFT: 'ArrowLeft',
  ESCAPE: 'Escape',
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
  TAB: 'Tab',
  SPACE: ' ',
} as const;

export default keyboardKeys;
